export default "__VITE_ASSET__140b3116__"